/**
 * Formats an E.164 number for display with spacing.
 * +12125551234 → "+1 212 555 1234"
 * Handles US/CA (+1) and other countries gracefully.
 */
export function formatE164(e164: string): string {
  if (!e164.startsWith('+')) return e164;
  // US/CA: +1 NXX NXX XXXX
  const m1 = e164.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (m1) return `+1 ${m1[1]} ${m1[2]} ${m1[3]}`;
  // Generic: split after country code (1-3 digits) then chunks of 3-4
  const digits = e164.slice(1);
  // country code is first 1-3 digits; heuristic: match leading 1-3 digit prefix
  const m2 = digits.match(/^(\d{1,3})(.+)$/);
  if (!m2) return e164;
  const cc = m2[1] ?? '';
  const rest = (m2[2] ?? '').replace(/(\d{3,4})(?=\d)/g, '$1 ').trim();
  return `+${cc} ${rest}`;
}
